import React, { useState, useEffect } from 'react';
import { Timer } from 'lucide-react';

/** Live elapsed-time display that ticks every second. */
export default function ElapsedTimer({ startedAt }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const start = new Date(startedAt).getTime();
  const sec = Math.max(0, Math.floor((now - start) / 1000));
  const mm = Math.floor(sec / 60);
  const ss = String(sec % 60).padStart(2, '0');
  return (
    <div className="flex items-center gap-1.5 text-muted-foreground" data-testid="elapsed-timer">
      <Timer className="h-3.5 w-3.5" />
      <span className="font-mono text-sm tabular-nums">{mm}:{ss}</span>
    </div>
  );
}
